import { format as dateFnsFormat } from 'date-fns';
import { fr, enCA } from 'date-fns/locale';
import i18n from '../vue/i18n';

/**
 * @param {Date|Number} date - Date à formater
 * @param {String} formatStr - Le format souhaité
 * @param {Object} options - Options supplémentaires (la langue sera ajoutée automatiquement)
 * @returns {String} - La date formatée
 */
export function format(date, formatStr, options = {}) {
    return dateFnsFormat(date, formatStr, {
        ...options,
        locale: (options.locale ?? i18n.global.locale.value) === 'fr' ? fr : enCA,
    });
}

export {
    parseISO,
    formatISO,
    addDays,
    subDays,
    addHours,
    subHours,
    setHours,
    addMinutes,
    subMinutes,
    getMinutes,
    setMinutes,
    startOfMinute,
    isBefore,
    isAfter,
    isToday,
    isWithinInterval,
    startOfDay,
    endOfDay,
} from 'date-fns';
